<script>
import VueTimepicker from 'vue2-timepicker';
import moment from 'moment-timezone';

export default {
    components: {
        VueTimepicker,
    },

    props: {
        startValue: {
            type: String,
            default: '13:00:00',
        },

        parseTime: {
            type: Boolean,
            default: true,
        },

        format: {
            type: String,
            default: 'hh:mm a',
        },

        minuteInterval: {
            type: [Number],
            default: null,
        },

        secondInterval: {
            type: [Number],
            default: null,
        },

        hideClearButton: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            value: '13:00:00',
        };
    },

    computed: {
        formattedTime: {
            get() {
                if (this.parseTime) {
                    const dateTime = moment(`2019-09-01 ${this.value}`, 'YYYY-MM-DD hh:mm A');
                    const HH = dateTime.format('HH');
                    const hh = dateTime.format('hh');
                    const mm = dateTime.format('mm');
                    const ss = dateTime.format('ss');
                    const a = dateTime.format('a');

                    const data = {
                        HH,
                        hh,
                        mm,
                        ss,
                        a,
                    };
                    return data;
                }
                return this.value;
            },

            set(data) {
                const time = data.data;
                this.value = moment().hour(time.HH).minute(time.mm).second(time.ss)
                    .format('HH:mm:ss');
            },
        },
    },

    watch: {
        startValue: {
            immediate: true,
            handler(value) {
                if (value.length > 0) {
                    this.value = value;
                }
            },
        },
    },

    methods: {
        handleChange(data) {
            this.formatTime(data);
            this.$emit('change', this.value);
        },

        formatTime(data) {
            if (this.parseTime) {
                this.formattedTime = data;
            }
        },
    },
};
</script>

<template>
    <vue-timepicker
        :value="formattedTime"
        :format="format"
        :minute-interval="minuteInterval"
        :second-interval="secondInterval"
        :hide-clear-button="hideClearButton"
        @change="handleChange"
    />
</template>
